<script setup lang="ts">
import { useReference } from '@/core/composables/useReference'
import { toRefs } from 'vue'

interface Props {
  /** Reference object data */
  reference: ReferenceInterface
}

const props = defineProps<Props>()

defineOptions({
  name: 'ReferenceStatusText'
})

const { reference } = toRefs(props)

const { statusVariant, statusText } = useReference(reference)
</script>

<template>
  <span class="status-text text-xs" :class="`status-text-${statusVariant}`">
    {{ statusText }}
  </span>
</template>

<style scoped lang="scss">
@reference '../../styles/main.css';

.status-text {
  @apply text-red-500;
}

.status-text-primary {
  @apply text-orange-500;
}

.status-text-success {
  @apply text-green-400;
}
</style>
